import axios from "axios";
import { z } from "zod";
import { toast } from "../../components/ui/use-toast";
import { CircleCheckBig } from "lucide-react";
import { formatDateToYYYYMMDDLocal } from "../../utils/dateUtils";
const baseUrl = process.env.REACT_APP_SERVER_URL;

export const getAllProjects = async () => {
  try {
    const response = await axios.get(`${baseUrl}/api/projects`);
    return { projects: response.data.projects };
  } catch (error) {
    console.error(error);
  }
};

export const getAllPaginatedProjects = async (page: number) => {
  try {
    const response = await axios.get(
      `${baseUrl}/api/projects/all?page=${page}`
    );

    return {
      news: response.data.news,
      count: response.data.count,
      totalPages: response.data.totalPages,
    };
  } catch (error) {
    console.error(error);
  }
};

export const getProjectBySlug = async (slug: string) => {
  try {
    const response = await axios.get(`${baseUrl}/api/projects/slug/${slug}`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const handleCreateProject = async (
  formData: any,
  navigate: Function
) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
    };

    const processedFormData = { ...formData };
    if (processedFormData.date_debut instanceof Date) {
      processedFormData.date_debut = formatDateToYYYYMMDDLocal(processedFormData.date_debut);
    }
    if (processedFormData.date_fin instanceof Date) {
      processedFormData.date_fin = formatDateToYYYYMMDDLocal(processedFormData.date_fin);
    }

    const response = await axios.post(
      `${baseUrl}/api/projects/`,
      processedFormData,
      config
    );

    toast({
      variant: "destructive",
      className: "bg-green-500 border border-green-500",
      description: (
        <div className="flex items-center">
          <CircleCheckBig className="mr-2" />
          <span className="first-letter:capitalize">{response.data.msg}</span>
        </div>
      ),
    });
    navigate("/admin-dashboard/travaux");
  } catch (error: any) {
    if (error instanceof z.ZodError) {
      const fieldErrors: { [key: string]: string } = {};
      error.errors.forEach((err: any) => {
        fieldErrors[err.path[0]] = err.message;
      });
    } else {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast({
          variant: "destructive",
          title: "Une erreur s'est produite.",
          description: error.response.data.message,
          className: "bg-red-500 border border-red-500",
        });
        return error.response.data.message;
      }
    }
  }
};

export const handleUpdateProject = async (
  id: number,
  formData: any,
  navigate: Function
) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
    };

    const processedFormData = { ...formData };
    if (processedFormData.date_debut instanceof Date) {
      processedFormData.date_debut = formatDateToYYYYMMDDLocal(processedFormData.date_debut);
    }
    if (processedFormData.date_fin instanceof Date) {
      processedFormData.date_fin = formatDateToYYYYMMDDLocal(processedFormData.date_fin);
    }

    const response = await axios.patch(
      `${baseUrl}/api/projects/${id}`,
      processedFormData,
      config
    );
    if (response.data?.msg) {
      toast({
        variant: "destructive",
        title: "Opération réussie.",
        description: response?.data?.msg,
        className: "bg-green-500 border border-green-500",
      });
      navigate("/admin-dashboard/travaux");
    }
  } catch (error: any) {
    if (error instanceof z.ZodError) {
      const fieldErrors: { [key: string]: string } = {};
      error.errors.forEach((err: any) => {
        fieldErrors[err.path[0]] = err.message;
      });
    } else {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast({
          variant: "destructive",
          title: "Une erreur s'est produite.",
          description: error.response.data.message,
          className: "bg-red-500 border border-red-500",
        });
        return error.response.data.message;
      }
    }
  }
};

export const deleteProject = async (id: number) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    };

    const response = await axios.delete(
      `${baseUrl}/api/projects/${id}`,
      config
    );

    toast({
      variant: "destructive",
      className: "bg-green-500 border border-green-500",
      description: (
        <div className="flex items-center">
          <CircleCheckBig className="mr-2" />
          <span className="first-letter:capitalize">
            {response.data.message}
          </span>
        </div>
      ),
    });
  } catch (error) {
    console.error(error);
  }
};

export const getProjectById = async (id: number) => {
  try {
    const response = await axios.get(`${baseUrl}/api/projects/${id}`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
